import { useStore } from '@store/index';
import { buildRoutePath } from '@utils/routes';

export const useProgramSwitcher = () => {
  const { selectedOrganizationId, programs } = useStore();

  const switchToProgram = (programId: string, navigateTo: string = '/cases') => {
    if (!selectedOrganizationId) {
      console.error('No organization selected');
      return;
    }

    // Check if program exists
    if (!programs[programId]) {
      console.error(`Program ${programId} does not exist`);
      return;
    }
    // Navigate to the appropriate route
    const path = buildRoutePath(navigateTo, selectedOrganizationId, programId);
    window.location.href = path;
  };

  return { switchToProgram };
};
